import React, { useState, useRef, useEffect } from "react";
import { api } from "../api";

export default function ForgotPassword({ onBack }) {
  const [email, setEmail]     = useState("");
  const [error, setError]     = useState("");
  const [done, setDone]       = useState(false);
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.forgotPassword(email.trim().toLowerCase());
      if (mountedRef.current) setDone(true);
    } catch (err) {
      if (mountedRef.current) setError(err.message);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-institution">
          <span className="login-dept">Dipartimento di Oncologia Sperimentale</span>
          <h1>Recupero password</h1>
          <p className="login-subtitle">
            Inserisci l'indirizzo email associato al tuo account.<br/>
            Riceverai un link per reimpostare la password.
          </p>
        </div>

        {done ? (
          <p className="login-success">
            ✓ Se l'indirizzo è registrato, riceverai a breve un'email con le istruzioni per reimpostare la password.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <label>
              <span>Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck="false"
                placeholder="nome@esempio.it"
                autoFocus
                required
              />
            </label>

            {error && <p className="login-error">⚠ {error}</p>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? "Invio in corso…" : "Invia link di recupero"}
            </button>
          </form>
        )}

        <button className="login-link" onClick={onBack}>← Torna al login</button>
      </div>
    </div>
  );
}
